import React from 'react';

interface TabsProps {
  children: React.ReactNode;
  className?: string;
  value: string;
  onChange: (value: string) => void;
}

export const Tabs: React.FC<TabsProps> = ({
  value: _value,
  onChange: _onChange,
  className,
  children,
}) => {
  return <div className={className}>{children}</div>;
};

interface TabsListProps {
  children: React.ReactNode;
  className?: string;
}

export const TabsList: React.FC<TabsListProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`
      inline-flex flex-nowrap items-center
      overflow-x-auto
      overflow-y-hidden
      border-b border-gray-200
      w-full
      ${className}
    `}
    >
      {children}
    </div>
  );
};

interface TabsTriggerProps {
  value: string;
  currentValue: string;
  onClick: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({
  value,
  currentValue,
  onClick,
  children,
  className = '',
}) => {
  const isActive = value === currentValue;

  return (
    <button
      onClick={() => onClick(value)}
      className={`
        min-w-[140px] px-6 py-3
        text-base
        relative
        transition-all duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${
          isActive
            ? 'text-blue-600 font-bold'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50/50 font-medium'
        }
        ${className}
      `}
    >
      {children}
      {isActive && (
        <span className="absolute bottom-[-1px] left-0 right-0 h-[2px] bg-blue-600" />
      )}
    </button>
  );
};

interface TabsContentProps {
  value: string;
  currentValue: string;
  children: React.ReactNode;
  className?: string;
}

export const TabsContent: React.FC<TabsContentProps> = ({
  value,
  currentValue,
  children,
  className = '',
}) => {
  if (value !== currentValue) return null;

  return (
    <div
      className={`
        pt-0 sm:pt-4
        pb-8
        bg-gray-100 
        animate-[fadeIn_0.2s_ease-in]
        ${className}
      `}
    >
      {children}
    </div>
  );
};
